var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import ChevronUpSvg from './chevron-up.icon.svg';
export const ChevronUpIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: ChevronUpSvg });
};
_react_refresh_temp_1 = ChevronUpIcon;
$RefreshReg$(_react_refresh_temp_1, "ChevronUpIcon");
